export default "__VITE_ASSET__JrDfUJr8__"